import axios from "axios";
import { config } from "../../utils/axiosconfig";
import { base_url } from "../../utils/baseUrl";

const getHealthAdvices = async () => {
  const response = await axios.get(`${base_url}health-advice`);
  return response.data;
};

const getAHealthAdvice = async (id) => {
  const response = await axios.get(`${base_url}health-advice/${id}`);
  return response.data;
};

const createHealthAdvice = async (advice) => {
  const response = await axios.post(`${base_url}health-advice`, advice, config);
  return response.data;
};

const updateHealthAdvice = async (id, advice) => {
  const response = await axios.put(`${base_url}health-advice/${id}`, advice, config);
  return response.data;
};

const deleteHealthAdvice = async (id) => {
  const response = await axios.delete(`${base_url}health-advice/${id}`, config);
  return response.data;
};

const healthAdviceService = {
  getHealthAdvices,
  getAHealthAdvice,
  createHealthAdvice,
  updateHealthAdvice,
  deleteHealthAdvice,
};

export default healthAdviceService;
